import { useFormat } from '@/app/state/preferences';
import { useT } from '@/i18n';
import { ALL_CATEGORIES, type ExperienceFilters } from '@/services/domain';
import { messages } from '../i18n';

export const DURATIONS: ExperienceFilters['duration'][] = ['', 'court', 'moyen', 'long', 'journee'];

/**
 * Labels of the experience search in the current language (the caller re-renders on a language change).
 * The filter values stay as they are (`ALL_CATEGORIES`, the duration ids, server category names).
 */
export function useSearchLabels() {
  const t = useT(messages);
  const f = useFormat();
  /** «1 – 3h»; «Toutes» for any duration (the chip). */
  const duration = (k: ExperienceFilters['duration']) => (k ? t(`duration.${k}`) : t('search.allDurations'));
  /** «Toutes les catégories» for `ALL_CATEGORIES`, else the server's name. */
  const category = (c: string) => (c === ALL_CATEGORIES ? t('search.allCategories') : c);
  return {
    duration,
    category,
    /** «Marrakech · ven. 13 nov.» or «Marrakech · Dates flexibles». */
    title: (x: ExperienceFilters) => `${x.city} · ${x.date ? f.dayShort(x.date) : t('search.flexible')}`,
    /** «Toutes les catégories · 1 – 3h». */
    sub: (x: ExperienceFilters) => `${category(x.category)}${x.duration ? ` · ${duration(x.duration)}` : ''}`,
  };
}
